export const KEY_PERCOBAAN = {
  KEY_SECTION_1: ["C", "E", "E"],
  KEY_SECTION_2: ["BD", "CE"],
  KEY_SECTION_3: ["B", "C", "F"],
  KEY_SECTION_4: ["C", "B", "D"],
};
